import { render, staticRenderFns } from "./chooseProducts.vue?vue&type=template&id=c506055e&scoped=true&"
import script from "./chooseProducts.vue?vue&type=script&lang=js&"
export * from "./chooseProducts.vue?vue&type=script&lang=js&"
import style0 from "./chooseProducts.vue?vue&type=style&index=0&id=c506055e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c506055e",
  null
  
)

export default component.exports